class VimeoThumbnails extends HTMLElement {
  connectedCallback () {
    const videoId = this.getAttribute('video-id')
    if (!videoId) return

    const container = this.querySelector('.vimeo-thumb__image-container')
    if (!container) return

    // Clear any existing content
    container.innerHTML = ''

    this.loadThumbnail(videoId, container)
  }

  loadThumbnail (videoId, container) {
    fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`)
      .then(res => {
        if (!res.ok) {
          throw new Error('Network response was not ok')
        }
        return res.json()
      })
      .then(data => {
        if (!data.thumbnail_url) {
          throw new Error('No thumbnail URL in response')
        }

        const img = document.createElement('img')
        img.src = data.thumbnail_url
        img.className = 'vimeo-thumb__image w-full h-full object-cover opacity-0 transition-opacity duration-300'
        img.loading = 'lazy'
        img.width = 220
        img.height = 176
        img.alt = this.getAttribute('alt') || ''

        // Add the image to the container immediately
        container.appendChild(img)

        // Once loaded, fade it in
        img.onload = () => {
          requestAnimationFrame(() => {
            img.classList.remove('opacity-0')
          })
        }

        img.onerror = () => {
          console.error('Failed to load image:', data.thumbnail_url)
        }
      })
      .catch(error => {
        console.error('Error loading Vimeo thumbnail:', error)
      })
  }
}

if (!customElements.get('vimeo-thumbnails')) {
  customElements.define('vimeo-thumbnails', VimeoThumbnails)
}
